module.exports = __webpack_public_path__ + "static/media/5.a6e6ade2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/5.jpg
// module id = 475
// module chunks = 0